import repositories from '..';

const resource = '/master/semesters';

export default {
  getInitData: () => repositories.get(`${resource}/data/init`),
};
